import classNames from 'classnames';
import React from 'react';
import { useField, ErrorMessage } from 'formik';

const Date = ({ label, disabled, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<div className='form__group'>
			<label className='form__label'>
				{label}
				<div className='form__validation'>
					<input
						className={classNames('form__input', {
							'form__input--error': meta.touched && meta.error,
						})}
						type='date'
						disabled={disabled}
						{...field}
						{...props}
					/>
					<ErrorMessage
						name={field.name}
						render={msg => <div className='form__helper'>{msg}</div>}
					/>
				</div>
			</label>
		</div>
	);
};

export default Date;
